var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr1AbtDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 239,
    viewBox: "0 0 176 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1608 203.813L91.4748 184.662L68.6921 171.654L64.2656 187.26C63.4291 190.209 61.4615 192.709 58.7911 194.214L45.1011 201.932L80.7449 222.363L90.6686 216.651C95.1517 214.07 97.3902 208.838 96.1608 203.813Z",
    fill: "#092256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6522 171.825L89.6935 184.41L94.3285 203.353C95.505 208.161 93.3627 213.168 89.0725 215.638L79.3977 221.207L44.7661 201.356L57.69 194.07C60.4752 192.5 62.5274 189.893 63.3999 186.817L67.6522 171.825Z",
    fill: "white",
    stroke: "#092256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7544 202.955V201.272L79.4314 221.467L81.1143 220.457V222.14L79.0948 223.486L43.7544 202.955Z",
    fill: "#092256"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2406 209.687L62.6025 190.838C64.0497 188.648 64.9586 184.443 66.978 177.375L90.5383 190.838C93.4425 201.417 94.2498 206.174 94.2406 209.687Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.626 94.0316L21.652 7.16761C16.1563 3.98455 9.27686 7.95011 9.27686 14.3011V132.897C9.27686 135.846 10.8521 138.571 13.4079 140.042L163.382 226.371C168.878 229.535 175.738 225.568 175.738 219.227V101.165C175.738 98.2239 174.171 95.5056 171.626 94.0316Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65771 10.9966L13.029 5.10741L172.767 227.959L163.334 233.64L2.65771 10.9966Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0304 13.0764L162.109 99.9852C164.442 101.336 165.879 103.828 165.879 106.524V224.648C165.879 230.461 159.59 234.097 154.553 231.198L4.47423 144.824C2.13116 143.475 0.686963 140.978 0.686963 138.274V19.6157C0.686963 13.7943 6.99265 10.1592 12.0304 13.0764Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.37393
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.973 101.764L22.4628 26.989C16.9941 23.903 10.2208 27.8202 10.1683 34.0994L9.31737 135.871C9.29236 138.861 10.8893 141.631 13.4903 143.108L146.851 218.831C152.347 221.951 159.165 217.982 159.165 211.662V108.943C159.165 105.969 157.563 103.226 154.973 101.764Z",
    fill: "#0357EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8189 24.8188L154.974 101.574C157.553 103.039 159.146 105.776 159.146 108.742V212.26C159.146 218.57 152.346 222.54 146.851 219.439L11.696 143.155C9.10617 141.694 7.50439 138.95 7.50439 135.976V31.9871C7.50439 25.6672 14.3234 21.6979 19.8189 24.8188ZM23.8347 27.7446L154.21 102.391C156.775 103.86 158.358 106.589 158.358 109.545V210.136C158.358 216.459 151.533 220.428 146.037 217.301L15.6617 143.113C13.0859 141.648 11.4951 138.912 11.4951 135.949V34.8985C11.4951 28.5658 18.339 24.598 23.8347 27.7446Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.156 13.1856L22.3059 7.55693L11.5698 13.1856L21.2115 18.8142L32.156 13.1856Z",
    fill: "#0357EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.523 105.172L175.738 99.4912C175.54 97.6062 174.525 95.9028 172.963 94.8303L172.768 94.6964L166.566 91.1003L155.83 96.729L163.282 101.055L163.648 101.351C164.804 102.287 165.49 103.684 165.523 105.172Z",
    fill: "#0357EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.951 15.9999L33.2507 13.8631L22.5146 19.4917L26.1628 21.6285L36.951 15.9999Z",
    fill: "#0357EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr1AbtDesktop);
export default __webpack_public_path__ + "static/media/tr1-abt-desktop.9f6f91046adaf5580e93ca2d96bb9ea6.svg";
export { ForwardRef as ReactComponent };